export enum VerticalAlign {
    Top = 'Top',
    Bottom = 'Bottom',
    Center = 'Center',
};
